import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Parts} from "components";
import {Button} from "reactstrap";
import GapTimers from "../../../../../components/Collections/GapTimers";

const breadcrumbsStatic = [{
	name: 'Hiring',
	url: '/hiring/heatmap',
	icon: 'ticket',
}];

export default class Hiring_Zones extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history,roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Hiring Zones",
				url: `/hiring/hiring_zones`,
				icon: 'laptop',
			}
		]);

		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>
				<Parts.Tickers.HiringTicker/>

				<Objects.HiringZonesMap
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showButtons={roles.includes(10)}
				/>
			</div>


		)
	}
}